/*
 * @Author       : yilei
 * @Date         : 2023-02-07 11:01:39
 * @LastEditTime : 2023-03-28 16:40:28
 * @LastEditors  : yilei
 */
import { getCookie, setCookie } from '@/utils/cookie'
import { getGrayInfo } from '@/services/api'

export const HOME_ROOT_MENU_ID = '9'
export const USE_NEW_LAYOUT_COOKIE = 'use_new_layout'
export const NEW_LAYOUT_COOKIE_AGE = 90
export const Y = 'Y'
export const N = 'N'

let layoutGrayInfo: string

export const GET_LAYOUT_GRAY_INFO = () => {
  if (!layoutGrayInfo) {
    const useNewLayout = getCookie(USE_NEW_LAYOUT_COOKIE)
    if (useNewLayout) {
      layoutGrayInfo = useNewLayout
      return Promise.resolve(useNewLayout)
    }
    return getGrayInfo('threenets_layout').then((res: { data: string }) => {
      if (res.data) {
        layoutGrayInfo = res.data
        // 和SSR页面共享灰度信息，用cookie解决
        setCookie(USE_NEW_LAYOUT_COOKIE, layoutGrayInfo, NEW_LAYOUT_COOKIE_AGE)
        return Promise.resolve(layoutGrayInfo)
      } else {
        return Promise.reject(res)
      }
    }).catch(err => Promise.reject(err))
  } else {
    return Promise.resolve(layoutGrayInfo)
  }
}
